export default __webpack_public_path__ + "static/media/bigLogo.998919e3.png";